export default "__VITE_ASSET__1cf764a9__"